<script setup lang="ts">
import { FairIcon } from '@/ui/primitives/FairIcon'
import type { FairIconName } from '@/ui/tokens/icons.data'

/**
 * Chip — DS "Controls" › Chip (399:23104).
 * Type=Default (fill/chip) / AI (lavender gradient @ 40%) · Size=Default / Mobile (min 44) ·
 * Default (secondary) / Hover (primary text) / Pressed (fill/pressed; AI 90% opacity) /
 * Focus (2px ring) / Disabled (muted) / Active (check icon, primary text).
 */
interface FairChipProps {
  label: string
  type?: 'default' | 'ai'
  size?: 'default' | 'mobile'
  active?: boolean
  disabled?: boolean
  leadingIcon?: FairIconName
  trailingIcon?: FairIconName
}

withDefaults(defineProps<FairChipProps>(), {
  type: 'default',
  size: 'default',
  active: false,
  disabled: false,
  leadingIcon: undefined,
  trailingIcon: undefined,
})

const emit = defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <button
    type="button"
    class="fair-chip"
    :class="{
      'fair-chip--ai': type === 'ai',
      'fair-chip--mobile': size === 'mobile',
      'fair-chip--active': active,
    }"
    :disabled="disabled"
    :aria-pressed="active"
    @click="emit('click', $event)"
  >
    <FairIcon v-if="leadingIcon" :name="leadingIcon" :size="12" />
    <FairIcon v-if="active" name="check" :size="12" />
    <span class="fair-chip__label">{{ label }}</span>
    <FairIcon v-if="trailingIcon" :name="trailingIcon" :size="12" />
  </button>
</template>
